export const GET_VISITOR_CLUB_DETAIL_REQUEST = 'club/GET_VISITOR_CLUB_DETAIL_REQUEST' as const;
export const GET_VISITOR_CLUB_DETAIL_SUCCESS = 'club/GET_VISITOR_CLUB_DETAIL_SUCCESS' as const;
export const GET_VISITOR_CLUB_DETAIL_FAILURE = 'club/GET_VISITOR_CLUB_DETAIL_FAILURE' as const;
export const GET_VISITOR_CLUB_DETAIL_INITIAL = 'club/GET_VISITOR_CLUB_DETAIL_INITIAL' as const;
